import * as R from "ramda";
import { v4 as uuidv4 } from "uuid";
import {
  getSelectedParcels,
  getSelectedStops,
} from "../../../selectors/ui/routeDetail";
import { validateStopMerge, createMoveParcelsRequests } from "../../stop";
import { showNotification, hideNotifications } from "../../notifications";
import { NotificationType } from "../../../../features/Notifier";
import {
  updateStop,
  setScheduleRequired,
  addStop,
  lockRoute,
} from "../../route";
import { getRemainingParcelCodes } from "../../../selectors/ui/routeDetail";
import { getRouteRequests, getRouteStops } from "../../../selectors/route";
import { generateNewStop, getStopParcelCodes } from "../../../../models/stop";
import { DISMISS } from "../../../../constants/strings";
import { getStopByNumber } from "../../../../features/routeDetail/model";
import { resetSelectedParcels } from "./selectedParcels";
import { getErrorMessage } from "../../../../utils/errors";

const SPLIT_STOP_NOTIFICATION_KEY = "split-stop-message";

const handleError = (error) => (dispatch) => {
  dispatch(
    showNotification({
      key: SPLIT_STOP_NOTIFICATION_KEY,
      type: NotificationType.ACTION,
      message: getErrorMessage(error),
      buttonText: DISMISS,
    })
  );
};

export const hideSplitStopNotifications = () => (dispatch) => {
  dispatch(hideNotifications([SPLIT_STOP_NOTIFICATION_KEY]));
};

export const fetchDestinationStop = (stopNumber) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const selectedParcelCodes = Object.keys(getSelectedParcels(state));
  const stops = getRouteStops(state);
  const requests = getRouteRequests(state);
  const stop = !R.isNil(stopNumber) && getStopByNumber(stops, stopNumber);
  if (stop) {
    const stopParcelCodes = getStopParcelCodes(stop);
    selectedParcelCodes.push(...stopParcelCodes);
  }
  try {
    const stopFromApi = await dispatch(
      validateStopMerge({
        parcels: selectedParcelCodes,
        checkOpenRequests: true,
      })
    );
    if (stop) {
      return { ...stop, ...stopFromApi };
    }
    return generateNewStop(stopFromApi, stops, requests);
  } catch (error) {
    dispatch(handleError(error));
  }
};

export const prepareSourceStop = () => async (dispatch, getState) => {
  const state = getState();
  const [selectedStop] = getSelectedStops(state);
  const remainingParcelCodes = getRemainingParcelCodes(state);
  const stopFromAPI = await dispatch(
    validateStopMerge({
      parcels: remainingParcelCodes,
      checkOpenRequests: true,
      splitStop: true,
    })
  );
  return { ...selectedStop, ...stopFromAPI };
};

export const onApplySplit = (toStop, isNewStop) => async (
  dispatch,
  getState
) => {
  const targetStop = isNewStop ? { ...toStop, stopId: uuidv4() } : toStop;
  const currentUserLock = await dispatch(lockRoute());

  if (!currentUserLock) {
    return;
  }

  const state = getState();
  const selectedParcels = Object.values(getSelectedParcels(state));
  try {
    const fromStop = await dispatch(prepareSourceStop());
    dispatch(updateStop(fromStop));
    isNewStop
      ? dispatch(addStop(targetStop))
      : dispatch(updateStop(targetStop));
    dispatch(createMoveParcelsRequests(selectedParcels, fromStop, targetStop));
    dispatch(setScheduleRequired(true));
    dispatch(resetSelectedParcels());
    dispatch(hideSplitStopNotifications());
    return true;
  } catch (error) {
    dispatch(handleError(error));
  }
};

export const splitStopActionCreators = {
  fetchDestinationStop,
  onApplySplit,
  hideSplitStopNotifications,
};
